import { z } from "zod";
import { getTranslatedStr, workflowSchemaHelpers } from "./AddWorkflowHelpers";
import { isEmpty } from "lodash";

const { nullableStr, nullableNumber, requiredSelect, multiselect} = workflowSchemaHelpers

export const WorkFlowFormSchema = z.object({
  id: nullableStr || nullableNumber,
  workflowName: requiredSelect,
  sampleIDs: multiselect,
  status: nullableNumber,
  draftSamples: nullableStr,
  samples: nullableStr
}).superRefine((values: any, ctx) => {
   if((!values.id && isEmpty(values.sampleIDs)) || (values.id && isEmpty(values.sampleIDs) && !values.status && !values.draftSamples && !values.samples)) {
    ctx.addIssue({
      message: getTranslatedStr('required'),
      code: z.ZodIssueCode.custom,
      path: ['sampleIDs'],
    });
   }
})